export const en = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    close: 'Close',
    logout: 'Logout',
    signOut: 'Sign Out',
    download: 'Download',
    upload: 'Upload',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    remove: 'Remove',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    retry: 'Retry',
    refresh: 'Refresh',
    copied: 'Copied!',
    copyMessage: 'Copy message',
    regenerate: 'Regenerate',
  },
  layout: {
    home: 'Home',
    workspace: 'Workspace',
    chat: 'Chat',
    musicVideo: 'Music Video',
    wan22Video: 'Wan 2.2 Video',
    singingPhoto: 'Singing Photo',
    randomSingingPhoto: 'Random Singing Photo',
    virtualInfluencer: 'Virtual Influencer',
    imageEdit: 'Image Edit',
    faceSwap: 'Face Swap',
    textToImage: 'Text to Image',
    nextScene: 'Next Scene',
    ltxVideo: 'LTX Video',
    videoAddSound: 'Video Add Sound',
    multiAngle: 'Multi-Angle View',
    humanPortrait: 'Human Portrait',
    models: 'Models',
    history: 'History',
    generationHistory: 'Generation History',
    organization: 'Organization',
    team: 'Team',
    apiTokens: 'API Tokens',
    usage: 'Usage',
    billing: 'Billing',
    system: 'System',
    modelEditor: 'Model Editor',
    providerEditor: 'Provider Editor',
    orgEditor: 'Org Editor',
    myCredits: 'My Credits',
  },
  login: {
    title: 'Pipelet.ai',
    subtitle: 'Sign in to continue',
    continueWithGoogle: 'Continue with Google',
    continueWithGithub: 'Continue with GitHub',
    signInWithPassword: 'Sign in with Email and Password',
    signInWithOAuth: 'Sign in with Google or GitHub',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    or: 'OR',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
  },
  welcome: {
    greeting: 'Welcome, {name}!',
    loading: 'Loading...',
    getStarted: 'Get started by creating a new organization or joining an existing one.',
    enterInviteCode: 'Enter the invite code provided by your organization',
    createOrganization: 'Create Organization',
    joinOrganization: 'Join Organization',
    organizationName: 'Organization Name',
    chooseName: 'Choose a name for your organization',
    inviteCode: 'Invite Code',
    creating: 'Creating...',
    joining: 'Joining...',
    create: 'Create',
    join: 'Join',
  },
  home: {
    title: 'Home',
    tryAiModels: 'Try AI Models',
    exploreAiModels: 'Explore our collection of AI models from text generation to video creation',
    categories: {
      workspace: {
        title: 'Workspace',
        description: 'LLM-driven media generation with chat interface and library',
      },
      chat: {
        title: 'Chat',
        description: 'Chat with AI models in real-time with streaming responses',
      },
      image: {
        title: 'Image',
        description: 'Generate, edit, and transform images with AI',
      },
      audio: {
        title: 'Audio',
        description: 'Text-to-speech, speech-to-text, and music generation',
      },
      video: {
        title: 'Video',
        description: 'Create and edit videos with generative AI',
      },
      virtualInfluencer: {
        title: 'Virtual Influencer',
        description: 'Multi-step workflow for voice, video, and enhancement',
      },
      workflows: {
        title: 'Workflows',
        description: 'Multi-step AI pipelines for complex tasks',
      },
      data: {
        title: 'Data',
        description: 'Embeddings, classification, and data processing',
      },
    },
  },
  team: {
    title: 'Team',
    loading: 'Loading...',
    inviteMembers: 'Invite Members',
    generateSingleUseInvite: 'Generate Single-Use Invite',
    generateMultiUseInvite: 'Generate Multi-Use Invite',
    inviteCodeLabel: 'Invite Code:',
    organizationMembers: 'Organization Members',
    member: 'Member',
    admin: 'Admin',
    remove: 'Remove',
    failedToLoadMembers: 'Failed to load members',
    failedToGenerateInvite: 'Failed to generate invite',
    failedToUpdateRole: 'Failed to update role',
    failedToRemoveMember: 'Failed to remove member',
  },
  chat: {
    title: 'Chat',
    selectModel: 'Select a model',
    typeMessage: 'Type your message...',
    send: 'Send',
    thinking: 'thinking',
    showThinking: 'Show thinking',
    hideThinking: 'Hide thinking',
    copyMessage: 'Copy message',
    regenerate: 'Regenerate',
    delete: 'Delete',
    copied: 'Copied!',
    apiExamples: 'API Examples',
    failedToLoadModels: 'Failed to load available models',
    modelWarmingUp: 'Model is warming up. Retrying in {seconds}s...',
    rateLimitExceeded: 'Rate limit exceeded. Retrying in {seconds}s...',
    errorOccurred: 'An error occurred',
    startConversation: 'Start a conversation by selecting a model and typing a message',
  },
  workspace: {
    title: 'Workspace',
    library: 'Library',
    clearWorkspace: 'Clear workspace',
    uploadMedia: 'Upload Media',
    selectedMedia: 'SELECTED MEDIA',
    noMediaYet: 'No media yet. Add files to get started.',
    describeWhatYouWant: 'Describe what you want to create...',
    usingSelectedItems: 'Using {count} selected item(s) as input',
    selectMediaOrDescribe: 'Select media from the library or just describe what you want',
    startConversation: 'Start a conversation with an AI model',
    selectModelAndType: 'Select a model and describe what you want to create',
    modelWarmingUp: 'Model is warming up...',
    modelWarmingUpDescription: 'This usually takes a few minutes for the first request. The model is being loaded onto the GPU.',
    retryingIn: 'Retrying in {seconds}s',
    retryingNow: 'Retrying now...',
    takingLonger: 'Taking longer',
    taskDetails: 'Task Details',
    status: 'STATUS',
    requestUrl: 'REQUEST URL',
    requestPayload: 'REQUEST PAYLOAD',
    close: 'Close',
  },
  musicVideo: {
    title: 'Music Video',
    searchGenerations: 'Search generations...',
    import: 'Import',
    create: 'Create',
    syncingJobStatus: 'Syncing job status...',
    noGenerationsYet: 'No music video generations yet',
    getStarted: 'Get started by creating your first music video',
    completed: 'Completed',
    processing: 'Processing',
    queued: 'Queued',
    failed: 'Failed',
    importVideo: 'Import Music Video',
    enterInstanceUuid: 'Enter Instance UUID',
    instanceUuidPlaceholder: 'Enter the instance UUID to import',
    cancel: 'Cancel',
    importButton: 'Import',
    importing: 'Importing...',
    deleteConfirmation: 'Delete Generation',
    deleteConfirmationMessage: 'Are you sure you want to delete this generation? This action cannot be undone.',
    deleting: 'Deleting...',
    generateVideo: 'Generate Video',
    generateComplete: 'Complete',
    submittingRequest: 'Submitting Your Request...',
    pleaseWait: 'Please wait while we process your music video generation request',
    generationStarted: 'Generation Started Successfully!',
    generationStartedDescription: 'Your music video is being generated. You can view the progress and edit the video once it\'s ready.',
    backToList: 'Back to List',
    viewGeneration: 'View Generation',
  },
  randomSingingPhoto: {
    title: 'Random Singing Photo',
    model: 'Model:',
    orientation: 'Orientation',
    portrait: 'Portrait (480x834)',
    landscape: 'Landscape (834x480)',
    batchSize: 'Batch Size',
    duration: 'Duration',
    seconds: 'seconds',
    generateRandom: 'Generate a random singing photo',
    enterPromptOrRandom: 'Enter a prompt (or leave empty for "random") to generate an image, then automatically create a singing photo video',
    describeImageStyle: 'Describe the image style (or leave empty for "random")...',
    submittingRequest: 'Submitting request...',
    generationInProgress: 'Generation in progress...',
    pressEnterToRegenerate: 'Press Enter to regenerate with same settings',
    pressEnterToGenerate: 'Press Enter to generate, Shift+Enter for new line. Leave empty for random style.',
    viewApiExamples: 'View API examples',
    startNewGeneration: 'Start new generation',
    queued: 'Queued',
    generatingImage: 'Generating Image',
    imageGenerationFailed: 'Image generation failed',
    videoPlaybackError: 'Video Playback Error',
    imagePreview: 'Image Preview',
    videoQueued: 'Video Queued',
    generatingVideo: 'Generating Video',
    creatingSingingPhoto: 'Creating singing photo video from generated image...',
    imageGenerated: 'Image Generated',
    selectDurationAndGenerate: 'Select duration and click to generate video',
    generateVideo: 'Generate Video',
    starting: 'Starting...',
    regenerate: 'Regenerate',
    delete: 'Delete',
    justNow: 'Just now',
    minutesAgo: '{minutes}m ago',
    hoursAgo: '{hours}h ago',
    daysAgo: '{days}d ago',
    expired: 'EXPIRED',
    failed: 'FAILED',
  },
  singingPhoto: {
    title: 'Singing Photo',
    model: 'Model:',
    duration: 'Duration',
    seconds: 'seconds',
    uploadImageRequired: 'Upload an image (required)',
    clickToSelectOrDrag: 'Click to select or drag and drop',
    describeVideo: 'Describe the singing photo video you want to generate...',
    generationInProgress: 'Generation in progress...',
    pressEnterToRegenerate: 'Press Enter to regenerate with same settings',
    pressEnterToGenerate: 'Press Enter to generate, Shift+Enter for new line',
    viewApiExamples: 'View API examples',
    startNewGeneration: 'Start new generation',
    queued: 'Queued',
    generatingSingingPhoto: 'Generating Singing Photo Video',
    somethingWentWrong: 'Something went wrong. Please retry.',
    videoPlaybackError: 'Video Playback Error',
    selectFromHistoryOrStart: 'Select a generation from history or start a new one',
    justABitLonger: 'Just a bit longer...',
    regenerateWithSettings: 'Regenerate with same settings',
    delete: 'Delete',
    justNow: 'Just now',
    minutesAgo: '{minutes}m ago',
    hoursAgo: '{hours}h ago',
    daysAgo: '{days}d ago',
  },
  textToImage: {
    title: 'Text to Image',
    model: 'Model:',
    width: 'Width',
    height: 'Height',
    batchSize: 'Batch Size',
    nsfw: 'NSFW',
    describeImage: 'Describe the image you want to generate...',
    jobInProgress: 'Job in progress...',
    pressEnterToRegenerate: 'Press Enter to regenerate with same settings',
    pressEnterToGenerate: 'Press Enter to generate, Shift+Enter for new line',
    generationFailed: 'Generation failed',
    queued: 'Queued',
    processing: 'Processing...',
    generatingImages: 'Generating {count} image{plural}...',
    enterPromptToGenerate: 'Enter a prompt to generate an image',
    viewApiExamples: 'View API examples',
    startNew: 'Start new',
    new: 'New',
    justNow: 'Just now',
    minutesAgo: '{minutes}m ago',
    hoursAgo: '{hours}h ago',
    daysAgo: '{days}d ago',
  },
  nextScene: {
    title: 'Next Scene Generator',
    uploadImage: 'Upload Image',
    dropImage: 'Drop the image here',
    dragDropOrClick: 'Drag & drop an image here, or click to select',
    supportedFormats: 'Supported formats: PNG, JPG, JPEG, WebP',
    removeImage: 'Remove Image',
    prompt: 'Describe the Next Scene',
    promptPlaceholder: 'What happens next in the story? Describe the scene...',
    generate: 'Generate Next Scene',
    generating: 'Generating...',
    new: 'New Generation',
    results: 'Generated Scenes',
    processing: 'Generating next scenes...',
    scene: 'Scene',
    noResults: 'No scenes generated yet',
  },
  history: {
    title: 'Generation History',
    description: 'View and manage your generation history',
    table: {
      createdAt: 'Created',
      model: 'Model',
      endpoint: 'Type',
      duration: 'Duration',
      credits: 'Credits',
      status: 'Status',
    },
    status: {
      success: 'Success',
      failed: 'Failed',
      pending: 'Pending',
      processing: 'Processing',
    },
    detail: {
      title: 'Generation Details',
      requestId: 'Request ID',
      model: 'Model',
      endpoint: 'Endpoint',
      createdAt: 'Created At',
      status: 'Status',
      credits: 'Credits Used',
      duration: 'Duration',
      metadata: 'Metadata',
      download: 'Download',
      delete: 'Delete',
      noSelection: 'Select a generation from the list to view details',
    },
    filters: {
      all: 'All',
      success: 'Success',
      failed: 'Failed',
      model: 'Filter by Model',
      status: 'Filter by Status',
    },
    empty: 'No generation history yet',
    deleteConfirm: 'Are you sure you want to delete this generation?',
    deleteSuccess: 'Generation deleted successfully',
    deleteFailed: 'Failed to delete generation',
  },
  ltxVideo: {
    title: 'LTX Video Generation',
    description: 'Generate videos with multi-frame guidance. Upload a first frame (required), optionally add a last frame and up to 3 middle frames for precise control.',
    firstFrame: 'First Frame',
    lastFrame: 'Last Frame (Optional)',
    middleFrames: 'Middle Frames (Optional)',
    middleFrame1: 'Middle Frame 1',
    middleFrame2: 'Middle Frame 2',
    middleFrame3: 'Middle Frame 3',
    dropImage: 'Drop the image here',
    dragDropOrClick: 'Drag & drop an image here, or click to select',
    supportedFormats: 'Supported formats: PNG, JPG, JPEG, WebP',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe what happens in the video...',
    settings: 'Settings',
    model: 'Model',
    duration: 'Duration',
    resolution: 'Resolution',
    priority: 'Priority',
    higherQuality: 'Higher quality with more steps',
    generate: 'Generate Video',
    generating: 'Generating video...',
    generatingInfo: 'View results in History. Safe to leave this page.',
    estimatedTime: 'Estimated time: ~{time} seconds',
    timeRemaining: 'Time remaining: ~{time} seconds',
    generationComplete: 'Video generation complete!',
    downloadVideo: 'Download Video',
    newGeneration: 'New Generation',
    errorFirstFrameAndPrompt: 'Please upload a first frame and enter a prompt',
    generateNeedFirstFrame: 'Generate Video (first frame needed)',
    generateNeedPrompt: 'Generate Video (prompt needed)',
    generateNeedBoth: 'Generate Video (first frame and prompt needed)',
  },
  imageEdit: {
    title: 'Image Edit',
    model: 'Model:',
    width: 'Width',
    height: 'Height',
    nsfw: 'NSFW',
    describeEdit: 'Describe how to edit the image(s)...',
    jobInProgress: 'Job in progress...',
    pressEnterToRegenerate: 'Press Enter to regenerate with same settings',
    pressEnterToGenerate: 'Press Enter to generate, Shift+Enter for new line',
    generationFailed: 'Generation failed',
    queued: 'Queued',
    processing: 'Processing...',
    setInputsAndGenerate: 'Set inputs and generate an edited image',
    viewApiExamples: 'View API examples',
    startNew: 'Start new',
    new: 'New',
    image1Primary: 'Image 1 (primary)',
    image2Optional: 'Image 2 (optional)',
    image3Optional: 'Image 3 (optional)',
    upload: 'Upload',
    orPasteUrl: 'Or paste URL',
    pleaseUploadValidImage: 'Please upload a valid image file',
    pleaseEnterPrompt: 'Please enter a prompt',
    failedToSubmit: 'Failed to submit image edit job',
    justNow: 'Just now',
    minutesAgo: '{minutes}m ago',
    hoursAgo: '{hours}h ago',
    daysAgo: '{days}d ago',
  },
  faceSwap: {
    title: 'Face Swap',
    uploadInstructions: 'Upload the base image and at least one reference face image. The face(s) from reference images will be swapped into the base image.',
    image1BaseBody: 'Base Image (body)',
    image2ReferenceFace1: 'Reference Face 1',
    image3ReferenceFace2: 'Reference Face 2 (optional)',
    image4ReferenceFace3: 'Reference Face 3 (optional)',
    upload: 'Upload',
    orPasteUrl: 'Or paste URL',
    referenceFaceHint: 'Tip: use a clear portrait where the face is large and centered for best results.',
    addExtraFaces: 'Add extra reference faces (optional)',
    hideExtraFaces: 'Hide extra reference faces',
    generate: 'Generate Face Swap',
    regenerate: 'Regenerate',
    jobInProgress: 'Processing...',
    generationFailed: 'Generation failed',
    queued: 'Queued',
    processing: 'Processing...',
    estimatedTime: 'Estimated time: ~2 minutes',
    uploadImagesAndGenerate: 'Upload base image + reference face(s) to generate',
    new: 'New',
    pleaseUploadValidImage: 'Please upload a valid image file',
    pleaseUploadBaseImage: 'Please upload or provide a URL for the base image',
    pleaseUploadReferenceFace: 'Please upload or provide a URL for at least one reference face',
    failedToSubmit: 'Failed to submit face swap job',
  },
  videoGeneration: {
    title: 'Video Generation',
    model: 'Model:',
    duration: 'Duration',
    seconds: 'seconds',
    uploadImageOptional: 'Upload an image (optional)',
    clickToSelectOrDrag: 'Click to select or drag and drop',
    describeVideo: 'Describe the video you want to generate...',
    generationInProgress: 'Generation in progress...',
    pressEnterToRegenerate: 'Press Enter to regenerate with same settings',
    pressEnterToGenerate: 'Press Enter to generate, Shift+Enter for new line',
    viewApiExamples: 'View API examples',
    startNewGeneration: 'Start new generation',
    queued: 'Queued',
    generatingVideo: 'Generating Video',
    justABitLonger: 'Just a bit longer...',
    somethingWentWrong: 'Something went wrong. Please retry.',
    videoPlaybackError: 'Video Playback Error',
    selectFromHistoryOrStart: 'Select a generation from history or start a new one',
    regenerateWithSettings: 'Regenerate with same settings',
    delete: 'Delete',
    pleaseUploadValidImage: 'Please upload a valid image file',
    pleaseEnterPrompt: 'Please enter a prompt',
    failedToGenerate: 'Failed to generate video',
    videoExpired: 'This video is no longer available (URLs expired)',
    failedToDownload: 'Failed to download video',
    justNow: 'Just now',
    minutesAgo: '{minutes}m ago',
    hoursAgo: '{hours}h ago',
    daysAgo: '{days}d ago',
  },
  virtualInfluencer: {
    title: 'Virtual Influencer Workflow',
    step1: '1. Speech Generation',
    step2: '2. Video Preview',
    step3: '3. Upscale to 1080p',
    step4: '4. High Frame Rate',
  },
  videoAddSound: {
    title: 'Video Add Sound',
    description: 'Add AI-generated sound effects and music to an existing video. Upload your video, describe the desired audio, and let the AI create the perfect soundtrack.',
    inputVideo: 'Input Video',
    dropVideo: 'Drop the video here',
    dragDropOrClick: 'Drag & drop a video here, or click to select',
    supportedFormats: 'Supported formats: MP4, MOV, WebM, AVI, MKV',
    prompt: 'Sound Prompt',
    promptPlaceholder: 'Describe the sounds you want to add, e.g. "footsteps on gravel, birds chirping, gentle breeze"...',
    generate: 'Add Sound to Video',
    generating: 'Generating sound...',
    generatingInfo: 'View results in History. Safe to leave this page.',
    estimatedTime: 'Estimated time: ~{time} seconds',
    timeRemaining: 'Time remaining: ~{time} seconds',
    generationComplete: 'Sound added to video successfully!',
    downloadVideo: 'Download Video with Sound',
    newGeneration: 'New Generation',
    errorVideoAndPrompt: 'Please upload a video and enter a sound prompt',
    generateNeedVideo: 'Add Sound (video needed)',
    generateNeedPrompt: 'Add Sound (prompt needed)',
    generateNeedBoth: 'Add Sound (video and prompt needed)',
  },
};

export type TranslationKeys = typeof en;
export default en;
